import { requiredRule, useFormControl } from "@mongez/react-form";
import { useEffect } from "react";
import { cn } from "~/shared/lib";
import { Check } from "../icons";
import type { BaseInputProps } from "./BaseInput";
import { ErrorInput } from "./ErrorInput";
import { LabelInput } from "./LabelInput";

type CheckboxInputProps = BaseInputProps;

export function CheckboxInput({
  label,
  classes,
  ...props
}: CheckboxInputProps) {
  const { id, name, checked, setChecked, error, otherProps } = useFormControl({
    ...props,
    type: "checkbox",
    rules: [requiredRule],
  });

  useEffect(() => {
    if (!props.defaultValue) return;
    setChecked(props.defaultChecked);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.defaultChecked]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    props.onChange?.(e.target.checked);
  };

  return (
    <div className="flex flex-col gap-2">
      <div className={cn("flex items-center gap-2", classes?.wrapper)}>
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={handleChange}
          {...otherProps}
          hidden
        />

        <label
          htmlFor={id}
          className={cn(
            "hover:bg-primary-default transition-color flex size-5 cursor-pointer items-center justify-center rounded-full border border-black text-white duration-300",
            checked && "bg-primary-default",
            classes?.input,
          )}
        >
          {checked && <Check className="text-white" />}
        </label>

        <LabelInput
          htmlFor={id}
          required={props.required}
          className={cn(classes?.label, error && "text-red-500")}
        >
          {label}
        </LabelInput>
      </div>

      <ErrorInput className={classes?.error}>{error}</ErrorInput>
    </div>
  );
}
